import axiosInstance from 'axios_s';
import * as apiroutes from '../../apiroutes';
import localStorageService from "./localStorageService";

class UserServices {

    // Get All users
    getAllUsers = async (params) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "get",
                url: apiroutes.USERS,
                params: params,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    getUserInfoById = async (id) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "get",
                url: apiroutes.USERS + id,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }

    //Hotel registration
    createUsers = async (data) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "post",
                url: apiroutes.USERS,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }

    updateUser = async (id, data) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "patch",
                url: apiroutes.USERS + '/' + id,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` },
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }


    // create customers

    //customer registration
    createCustomers = async (data) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "post",
                url: apiroutes.CUSTOMERS,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }

    getAllCustomer = async (params) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "get",
                url: apiroutes.CUSTOMERS,
                params: params,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    getCustoerInfoById = async (id) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "get",
                url: apiroutes.CUSTOMERS + '/' + id,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }

    updateCustomer = async (id, data) => {
        try {
            const accessToken = await localStorageService.getItem("accessToken");
            const config = {
                method: "patch",
                url: apiroutes.CUSTOMERS + '/' + id,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` },
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log("error", error);
            return error;
        }
    }

    changeCustomerStatus = async (id, data) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "put",
                url: apiroutes.CUSTOMERS + `/status/${id}`,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` },
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }


    // CUSTOMER_ACCOUNTS

    createCustomerStripeAccounts = async (data) => {
        try {
            const accessToken = await localStorageService.getItem('accessToken');
            const config = {
                method: "post",
                url: apiroutes.CUSTOMER_ACCOUNTS,
                data: data,
                headers: { Authorization: `Bearer ${accessToken}` }
            };
            const response = await axiosInstance(config);
            return response;
        } catch (error) {
            console.log('error', error);
            return error;
        }
    }

}

export default new UserServices()